'use client';

import React, { useCallback, memo } from 'react';
import { Grid } from '@shopify/polaris';

import { CategoryName, Template } from './types/template';
import TemplateCard from './TemplateCard';
import StudioRoutes from '@/utils/routes';
import useRouterNavigation from '@/hooks/useRouterNavigation';
import { useBannerState } from '@/hooks/useBannerState';
import { SessionBanner } from '@/types/banners';

interface TemplateCardsProps {
  templates: Template[];
  category?: CategoryName;
  useGridLayout?: boolean;
}

const TemplateCards: React.FC<TemplateCardsProps> = ({ templates, category, useGridLayout = true }) => {
  const { pushPath } = useRouterNavigation();

  const handleCardAction = useCallback(
    (template: Template) => {
      pushPath(
        StudioRoutes.createProject({
          template: template.id,
          category,
          stepperGenerationType: template.stepperGenerationType,
        })
      );
    },
    [pushPath, category]
  );

  const { useBannersPrefetch } = useBannerState();
  useBannersPrefetch([SessionBanner.BestImagesFetched, SessionBanner.FetchingBestImages]);

  if (useGridLayout) {
    return (
      <Grid columns={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3 }}>
        {templates.map((template) => (
          <TemplateCard key={template.id} template={template} onAction={handleCardAction} />
        ))}
      </Grid>
    );
  }

  return templates.map((template) => (
    <TemplateCard key={template.id} template={template} onAction={handleCardAction} />
  ));
};

export default memo(TemplateCards);
